<template>
  <div>
    <BrFilter @change="handleChange" />
    <BaseCountCard style="margin-top: 18px" :filter-form="filterForm" />
    <BrProgress style="margin-top: 18px" :filter-form="filterForm" />
    <a-row :gutter="20" style="margin-top: 20px">
      <a-col :span="12">
        <BrStatusCount :filter-form="filterForm" />
      </a-col>
      <a-col :span="12">
        <BrTargetCount :filter-form="filterForm" />
      </a-col>
    </a-row>
    <BrScoreCount style="margin-top: 20px" :filter-form="filterForm" />
    <BrInvalidStatusCount style="margin-top: 20px" :filter-form="filterForm" />
    <a-row :gutter="20" style="margin-top: 20px">
      <a-col :span="12">
        <BrScoreCountPie :filter-form="filterForm" />
      </a-col>
      <a-col :span="12">
        <BrTypeCountPie :filter-form="filterForm" />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import BrFilter from './components/BrFilter.vue';
import BaseCountCard from './components/BaseCountCard.vue';
import BrStatusCount from './components/BrStatusCount.vue';
import BrTargetCount from './components/BrTargetCount.vue';
import BrScoreCount from './components/BrScoreCount.vue';
import BrScoreCountPie from './components/BrScoreCountPie.vue';
import BrTypeCountPie from './components/BrTypeCountPie.vue';
import BrProgress from './components/BrProgress.vue';
import BrInvalidStatusCount from './components/BrInvalidStatusCount.vue';

export default {
  components: { BrFilter, BaseCountCard, BrStatusCount, BrTargetCount, BrScoreCount, BrScoreCountPie, BrTypeCountPie, BrProgress, BrInvalidStatusCount },
  data() {
    return {
      filterForm: {
        primaryDepartment: [],
        businessDepartment: []
      }
    };
  },
  methods: {
    handleChange(form) {
      this.filterForm = form;
    }
  }
};
</script>

<style lang="less" scoped></style>
